import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IChatSlashCommandService = ( createDecorator('chatSlashCommandService'));
export { IChatSlashCommandService };
